import { styled } from "@mui/material/styles";
import { Fab, List } from "@mui/material";

import { tintColor } from "@/theme/colors";

export const StyledList = styled(List)`
  .MuiListItem-root .Mui-selected {
    background-color: ${tintColor};
  }
`;

export const StyledIcon = styled(Fab)`
  bottom: 80px;
  display: flex;
  position: fixed;
  right: 20px;
  z-index: 2;

  svg {
    color: white;
  }

  @media (min-width: 960px) {
    display: none;
  }
`;
